// composables/useQueryParam.ts
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export function useReactiveQueryParam(key: string) {
  const route = useRoute()

  return computed(() => {
    const value = route.query[key]
    return typeof value === 'string' ? value : null
  })
}

export function useUpdateUrlParam() {
  const route = useRoute()
  const router = useRouter()

  const updateUrlParam = (key: string, value: string | null) => {
    const query = { ...route.query }

    if (value === null) {
      delete query[key]
    } else {
      query[key] = value
    }

    // Cập nhật URL mà không reload trang
    router.replace({ path: route.path, query })
  }

  return { updateUrlParam }
}
